export default {
  parentCompanyDetail: 'Parent Company Detail',
  parentCompanyJobList: 'Parent Company Job List',
  companyDetail: 'Company Detail',
  companyJobList: 'Company Job List',
  myReward: 'My Rewards',
  myRedeem: 'My Redeem',
  personalInfo: 'My Personal Information',
  aboutPlan: 'About Referral Program',
  jobDescription: 'Job Description',
  logout: 'Log out'
}
